import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=bdcc09a6"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=bdcc09a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports